// extracted by mini-css-extract-plugin
export default {"Toggle":"YesNoToggle_Toggle__mxH0b","Option":"YesNoToggle_Option__Yi7DU","Yes":"YesNoToggle_Yes__cve30","No":"YesNoToggle_No__ZgQNH","Disabled":"YesNoToggle_Disabled__3+bgB"};